// Parses a per-column statistic of a csv-inside report. Counts arrive as
// comma-separated strings ("379,281,111"), fill rates as ints (13) or decimal
// strings ("5.527"), and uncomputed values as null, undefined or the string
// "None". Returns a finite number, or null when the statistic is absent so
// callers can tell "no data" apart from a real zero.
export function parseStat(value) {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  if (value == null || value === "None" || value === "") {
    return null;
  }
  const number = Number(String(value).replaceAll(",", ""));
  return Number.isFinite(number) ? number : null;
}

export default { parseStat };
